import { render, staticRenderFns } from "./TemplateFault.vue?vue&type=template&id=07f7b13b&"
import script from "./TemplateFault.vue?vue&type=script&lang=ts&"
export * from "./TemplateFault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports